// extracted by mini-css-extract-plugin
export default {"goTop":"GoTop_goTop__v1f4k"};